<template>
    <div>404
	</div>
</template>

<script>
export default {
    name:'NotFound',
    data(){
        return {
            test:123
        }
    },
    mounted:function(){
        this.$store.commit("getIfShowMessage", false);
    }
}
</script>


// WEBPACK FOOTER //
// src/components/page/NotFound.vue